<template>
  <div>
    <Head title="Info"/>

    <div class="max-w-2xl mx-auto px-4">
      <div v-html="content.main"></div>
      <p class="my-4 pb-5 flex-col gap-4">
        <button class="link" @click="install()">App in Chrome installieren</button>
        <br class="block mb-4">
        <Link :href="'/pwa-installieren'" class="link">App in Safari/Firefox installieren</Link>
      </p>
      <div class="flex gap-4 mb-20">
        <dgvt-legal class=""/>
      </div>
    </div>

  </div>

</template>
<script>
import Layout from '../../Shared/Layout'
import {Head, Link} from '@inertiajs/inertia-vue3'
import DgvtLegal from '../../Shared/Navigation/DgvtLegal'

export default {

  name: 'Info',

  components: {
    Head,
    Link,
    DgvtLegal,
  },

  layout: Layout,

  props: {
    content: {
      type: Object,
      required: true,
    },
  },

  methods: {
    install: function () {
      localStorage.removeItem('refusePwa')
      window.location.href = 'login'
    },
  },
}
</script>

<style scoped>

</style>